<template>
  <v-row>
    <v-col cols="12">
      <search-card
        @clicked="(term) => getItems(term, this.$route.query.page)"
      />
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="pagination.total"
        :loading="loading"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:item.user_id="{ item }">
          <v-chip
            small
            outlined
            @click.stop="
              if (
                !authUser ||
                !['admin', 'superadmin'].includes(authUser.role)
              ) {
                return;
              }
              $router.push({
                name: 'dashboard-auth-user',
                params: { id: item.user_id },
              });
            "
          >
            {{ item.user.display_name }}
          </v-chip>
        </template>

        <template v-slot:item.questions_correct="{ item }">
          {{
            `(${item.questions_correct})${item.questions_attempted}/${item.questions_total}`
          }}
        </template>

        <template v-slot:item.points_obtain="{ item }">
          {{ `${item.points_obtain}/${item.points_total}` }}
        </template>
        <template v-slot:item.accuracy="{ item }">
          {{ `${item.accuracy}%` }}
        </template>
        <template v-slot:item.prep_mocktest_id="{ item }">
          <v-chip
            small
            outlined
            color="primary"
            @click.stop="
              $router.push({
                name: 'dashboard-prep-mocktests-segments',
                params: { id: item.mocktest.id },
              })
            "
            >{{ item.mocktest.title }}</v-chip
          >
        </template>

        <template v-slot:item.active="{ item }">
          <v-btn
            :id="'highlight-' + item.id"
            @click.stop="
              $store.dispatch('dashboard/prep/AttemptsToggleActive', {
                item,
              })
            "
            icon
            :color="item.active ? 'green' : 'red'"
          >
            <v-icon>{{
              item.active ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline"
            }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            class="mx-1"
            small
            icon
            @click="
              $router.push({
                name: 'dashboard-prep-attempts-get',
                params: { id: item.id },
                query: { parent_page: $route.query.page },
              })
            "
          >
            <v-icon>mdi-file</v-icon>
          </v-btn>
          <v-btn
            class="mx-1"
            small
            icon
            @click="
              $store
                .dispatch('dashboard/prep/AttemptsRemove', {
                  item,
                })
                .then(() => {
                  items = items.filter((el) => {
                    return el.id != item.id;
                  });
                })
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12">
      <query-page-redirect :pagination="pagination" />
      <!-- <v-pagination
        v-model="pagination.page"
        :length="pagination.lastPage"
      ></v-pagination> -->
    </v-col>
    <fab-button
      :icon="'mdi-plus'"
      color="primary"
      @clicked="$router.push({ name: 'dashboard-prep-attempts-create' })"
    />
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import FabButton from "@/components/FabButton.vue";
import { axios } from "@/plugins/axios";
import SearchCard from "../../modules/SearchCard.vue";
import bus from "@/bus";
import QueryPageRedirect from "@/components/QueryPageRedirect";

export default {
  name: "dashboard-prep-attempts",
  components: {
    FabButton,
    SearchCard,
    QueryPageRedirect,
  },
  data() {
    return {
      items: [],
      options: {},
      loading: false,
      where: "",
      headers: [
        { text: "Active", value: "active", sortable: true },
        { text: "User", value: "user_id", sortable: true },
        { text: "Questions", value: "questions_correct", sortable: true },
        { text: "Points", value: "points_obtain", sortable: true },
        { text: "Accuracy", value: "accuracy", sortable: true },
        { text: "Mocktest", value: "prep_mocktest_id", sortable: true },
        { text: "Date", value: "created_at", sortable: true },
        { text: "Actions", value: "actions", sortable: false },
      ],
      pagination: {
        lastPage: null,
        page: 1,
        perPage: null,
        total: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      authUser: "auth/user",
    }),
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    "pagination.page"(page) {
      if (page > 0) {
        // this.getItems();
      }
    },
  },
  methods: {
    getItems(term = "", currPage) {
      if (!currPage) {
        currPage = this.$route.query.page;
      }
      this.where = term;
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const ascDesc = sortDesc && sortDesc[0] ? "desc" : "asc";

      return axios
        .get(`/prep/attempts`, {
          params: {
            page: currPage ? currPage : 1,
            perPage: this.pagination.perPage,
            orderby:
              sortBy && sortBy.length > 0 ? `${sortBy[0]}|${ascDesc}` : ``,
            where: this.where,
          },
        })
        .then((res) => {
          // this.pagination = {
          //   lastPage: response.data.lastPage,
          //   page: response.data.page,
          //   perPage: response.data.perPage,
          //   total: response.data.total,
          // };
          this.pagination = {
            lastPage: res.data.lastPage,
            page: res.data.page,
            perPage: res.data.perPage,
            total: res.data.total,
          };

          this.items = res.data.data;
          return Promise.resolve(res.data);
        })
        .catch((error) => {
          return Promise.reject(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    // this.getItems();
  },
  updated() {
    bus.$on("highlightElement");
  },
};
</script>
